import TopNavBanner from "./TopNavBanner";
import Title from "./Title";
import styled from "@emotion/styled/macro";
import {PropsWithChildren, ReactNode} from "react";

const TopNavDefaultMain = styled.div`
  background-color: var(--content-background);
  display: flex;
  flex-direction: column; 
  height: 100%;
  
`

const TopNavDefaultContainer = styled.div`
  display:flex;
  flex-direction: column;
  align-items:center;
  flex-shrink: 0;
  justify-content: center;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  height:100px;
  flex: 0 0 100px;
  z-index:1;

  .contents {
    width: 100%;
  }
`

const DefaultLayout: React.FC<PropsWithChildren<{title:React.ReactNode, logoUrl?: string, right?: ReactNode}>> = ({title, logoUrl, children, right}) => {
    return <TopNavDefaultMain>
        <TopNavDefaultContainer>
                <TopNavBanner logoUrl={logoUrl ?? "/images/on2Logo.svg"} right={right}>
                    <Title>
                        {title}
                    </Title>
                </TopNavBanner>
        </TopNavDefaultContainer>
        {children}
    </TopNavDefaultMain>
}
export default DefaultLayout;
